<template>
    <div>
        <div id="swiper_max" class="builder">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide builder_wrapper" v-for="(item,key) in malldataList" :key="key">
                        <div class="builder_left">
                            <div class="builder_left_pic">
                                <div class="builder_left_pic">
                                    <div id="swiper_min" style="text-align: center">
                                        <div class="swiper-container2">
                                            <div class="swiper-wrapper">
                                                <div class="swiper-slide"  v-for="(val,key1) in item.images" :key="key1">
                                                    <img v-bind:src="val" />
                                                </div>
                                            </div>
                                            <!-- <div class="swiper-pagination"></div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="builder_left_info">
                                <div class="area_s">
                                    <span>占地面积/m<sup>2</sup></span>
                                    <span>{{item.area}}</span>
                                </div>
                                <!-- <div class="builder_left_info_year">
                                  <span>开业年份</span>
                                  <span>2001</span>
                                </div> -->
                            </div>
                        </div>

                        <div class="builder_center">
                            <div class="builder_center_title">{{item.name}}</div>
                            <div class="builder_center_txt">
                                <p>
                                    {{item.summary}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="builder_right">
                <div class="builder_swiper_top swiper-button-prev1">
                    <img src="@/assets/img/img_swiper1.png" />
                </div>
                <div class="swiper-pagination builder_swiper_content"></div>
                <div class="builder_swiper_top swiper-button-next1">
                    <img src="@/assets/img/img_swiper2.png" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import "@/assets/css/swiper.min.css";
    import Swiper from "@/assets/js/swiper.min.js";
    import "@/assets/css/builder_swiper.css";
    import * as echarts from "echarts";
    import { getBusinessOverview } from "@/api/third";
    import * as uepixel from "../../utils/ue-pixel.js";


    export default {
        data() {
            return {
                malldataList: [
                    {
                        "area": 7312,
                        "summary": "    位于中山路193-215号。来雅秉承着自身的特色和优势，顺应着市场的发展规则精益求精、不断进步，不仅在管理上更加细致、深入和完善，同时培养了一大批年轻的管理干部精英，为后续的持续发展奠定了坚实的基础，并不断向着输出管理、连锁经营的目标迈进。\n",
                        "images": [require("../../assets/img/right_1/right_1_1.jpg"), require("../../assets/img/right_1/right_1_2.jpg"), require("../../assets/img/right_1/right_1_3.jpg"), require("../../assets/img/right_1/right_1_4.jpg"), require("../../assets/img/right_1/right_1_5.jpg")],
                        "name": "来雅百货",
                        "openYear": 2001
                    }, {
                        "area": 23308.21,
                        "summary": "位于中山路1号。夏商百货以农产品、商业零售、旅游、物产物流、贸易、地产等为核心产业的现代大型企业集团，正稳步实施专业化经营、精细化管理，深化“立足厦门，布局福建，辐射海西，服务两岸”的跨区域拓展，用心践行“致力民生，创造价值”的企业使命，努力成为民生服务业的卓越典范。\n",
                        "images": [require("../../assets/img/right_1/right_1_1.jpg"), require("../../assets/img/right_1/right_1_2.jpg"), require("../../assets/img/right_1/right_1_3.jpg"), require("../../assets/img/right_1/right_1_4.jpg"), require("../../assets/img/right_1/right_1_5.jpg")],
                        "name": "夏商百货",
                        "openYear": 2001
                    }, {
                        "area": 19899,
                        "summary": "位于中山路76~132号。作为厦门中高端百货的领军代表，旗下汇集众多奢华品牌，打造了涵盖厦门地区全客层的商品优势， 并拥有得天独厚的地理优势以及稳定的顾客群体。巴黎春天百货中山店，焕发着时代的激情与活力，闪耀着顶级卖场的光芒 ，将秉承品牌国际高端的特性，提供更人性化的专业服务，为所有顾客带来更加愉悦美好的购物体验。\n",
                        "images": [require("../../assets/img/right_1/right_1_1.jpg"), require("../../assets/img/right_1/right_1_2.jpg"), require("../../assets/img/right_1/right_1_3.jpg"), require("../../assets/img/right_1/right_1_4.jpg"), require("../../assets/img/right_1/right_1_5.jpg")],
                        "name": "巴黎春天百货",
                        "openYear": 2001
                    }, {
                        "area": 112910.57,
                        "summary": " 位于思明南路189号。厦门中华城定位为高端的综合性商业中心。中华城所到之处，是将旅游、购物、餐饮、娱乐、休闲、品读集合为一体，从消费者消费感受的角度构建起来的，符合现代消费者消费理念的商业中心。中华城将辐射厦漳泉地区，\n" +
                            "                  以至整个海峡西岸商圈，借力中山路的核心商圈磁场，营造与国际接轨的大型商业中心，进一步扩大中高端消费市场，扩大厦门中华城在全国的影响力。",
                        "images": [require("../../assets/img/right_1/right_1_1.jpg"), require("../../assets/img/right_1/right_1_2.jpg"), require("../../assets/img/right_1/right_1_3.jpg"), require("../../assets/img/right_1/right_1_4.jpg"), require("../../assets/img/right_1/right_1_5.jpg")],
                        "name": "中华城",
                        "openYear": 2001
                    }, {
                        "area": 16987.41,

                        "summary": "位于思明南路118号。老虎城是一座米兰风情的时尚流行购物中心，是由香港金嶝国际投资和台湾群立流通顾问有限公司共同投资成立的。结合了香港金嶝国际投资雄厚的财团实力，和台湾群立流通顾问公司所拥有的先进的百货零售经营管理专业。\n" +
                            "                  老虎城将在永续经营的方向下，从厦门出发、稳步发展，全力打造成为中国最闪耀的通路品牌。",
                        "images": [require("../../assets/img/right_1/right_1_1.jpg"), require("../../assets/img/right_1/right_1_2.jpg"), require("../../assets/img/right_1/right_1_3.jpg"), require("../../assets/img/right_1/right_1_4.jpg"), require("../../assets/img/right_1/right_1_5.jpg")],
                        "name": "老虎城",
                        "openYear": 2001
                    }, {
                        "area": 63455.19,
                        "summary": "位于思明西路51号。南中广场从空间设计、业态规划、景观设置等诸多方面，打造以消费者为主题的购物休闲环境，是一个极具吸引力的大型商业休闲中心。 南中广场地处厦门中山路核心区位，铺铺临街金店面。南中大地广场精心设计多层次公园\n" +
                            "                  景观，珍贵植物错落有致，点缀雕塑，结合小品，形成立体的休闲景观空间，为顾客营造轻松、休闲、公园式的购物环境，让顾客在体味时尚缤纷购物乐趣的同时，感受极致浪漫的热带风情。",
                        "images": [require("../../assets/img/right_1/right_1_1.jpg"), require("../../assets/img/right_1/right_1_2.jpg"), require("../../assets/img/right_1/right_1_3.jpg"), require("../../assets/img/right_1/right_1_4.jpg"), require("../../assets/img/right_1/right_1_5.jpg")],
                        "name": "南中广场",
                        "openYear": 2001
                    }
                ]
            };
        },
        components: {},
        mounted() {
            let that = this;
            getBusinessOverview().then((res) => {
                that.malldataList = res.data.mall_desc.dataList;
            }).then(()=>{
                that.swiperMax();
                that.swiperMin();
            }).catch(e=>{
                that.swiperMax();
                that.swiperMin();
            });
        },

        created() {},
        methods: {
            swiperMax() {
                let that = this;
                new Swiper("#swiper_max .swiper-container", {
                    loop: true,

                    direction: "vertical",
                    autoplay: { disableOnInteraction: false ,delay:8000},
                    pagination: {
                        el: "#swiper_max .swiper-pagination",
                        dynamicBullets: true,
                        dynamicMainBullets: 7,
                        clickable: true,
                        renderBullet: function (index, className) {
                            let text = that.malldataList[index].name;

                            return '<div class="' + className + '">' + text + "</div>";
                        },
                    },
                    on: {
                        slideChangeTransitionStart: function slideChangeTransitionStart() {
                            let boxCollection= document.getElementsByClassName("swiper-pagination-bullet swiper-pagination-bullet-active swiper-pagination-bullet-active-main");
                            let text = "南中广场";
                            if(boxCollection.length!=0)text=boxCollection[0].innerHTML;
                            switch (text) {
                                case '南中广场':
                                    console.log("南中广场","118.085233,24.46109")
                                    uepixel.highlightBuilding("南中广场")
                                    break;
                                case '老虎城':
                                    console.log("老虎城","118.087391,24.459434")
                                    uepixel.highlightBuilding("老虎城")
                                    break;
                                case '中华城':
                                    console.log("中华城","118.089475,24.458577")
                                    uepixel.highlightBuilding("中华城")
                                    break;
                                case '来雅百货':
                                    console.log("来雅百货","118.088079,24.46091")
                                    uepixel.highlightBuilding("来雅百货")
                                    break;
                                case '巴黎春天百货':
                                    console.log("巴黎春天百货","118.084524,24.459861")
                                    uepixel.highlightBuilding("巴黎春天百货")
                                    break;
                                case '夏商百货':
                                    console.log("夏商百货","118.081725,24.459938")
                                    uepixel.highlightBuilding("夏商百货")
                                    break;
                                default:
                                    console.log("南中广场","118.085233,24.46109")
                            }
                            if (this.activeIndex == 1) {
                                this.allowSlidePrev = false;
                            } else {
                                this.allowSlidePrev = true;
                            }
                        },
                    },
                    navigation: {
                        nextEl: ".swiper-button-next1",
                        prevEl: ".swiper-button-prev1",
                    },
                });
            },
            swiperMin() {
                new Swiper("#swiper_min .swiper-container2", {
                    watchSlidesProgress: true,
                    slidesPerView: "auto",
                    centeredSlides: true,
                    observer: true,
                    loop: true,
                    observeParents: true,
                    // loopedSlides: 3,
                    autoplay: true,
                    spaceBetween: -70,
                });
            },
        },
    };
</script>
<style scoped src="@/assets/css/index3.css"></style>
<style >
    #swiper_min {
        width: 100%;
        height: 199px;
        margin: 0 auto;
    }
    #swiper_min img {
        width: 340px;
        height: 199px;
    }
    #swiper_min .swiper-container2 {
        width: 100%;
        height: 199px;
        margin: 0px auto;
    }

    #swiper_min .swiper-slide2 {
        width: 400px;
        height: 199px;
    }
    #swiper_min .swiper-slide-next {
        transform: scale(0.9);
    }
    #swiper_min .swiper-slide-prev {
        transform: scale(0.9);
    }
</style>
